import React from "react";
import ImageText from "./Elements/ImageText";
import social1Src from "../images/social-01.jpg";
import social1SrcRet from "../images/social-01@2x.jpg";
import social1Webp from "../images/social-01.webp";
import social1WebpRet from "../images/social-01@2x.webp";
import social2Src from "../images/social-02.jpg";
import social2SrcRet from "../images/social-02@2x.jpg";
import social2Webp from "../images/social-02.webp";
import social2WebpRet from "../images/social-02@2x.webp";

import social3Src from "../images/social-03.jpg";
import social3SrcRet from "../images/social-03@2x.jpg";
import social3Webp from "../images/social-03.webp";
import social3WebpRet from "../images/social-03@2x.webp";
import ArticleLink from "./Elements/ArticleLink";
import isMobile from "ismobilejs";

export default function Limites() {
    return (
        <section>
            <div className="container">

                <ImageText rtl={true}
                           image={{src: social1Src, srcRet: social1SrcRet, webp: social1Webp, webpRet: social1WebpRet}}>

                    {
                        isMobile().phone ? <div data-image-mobile/> : null
                    }

                    <p>
                        La pénurie risque d’ailleurs de durer encore un bon moment, à en croire les propos du directeur
                        en charge des semi-conducteurs chez Toshiba, Takeshi Kamebuchi. « L’approvisionnement en puces
                        restera fortement sous tension jusqu’à au moins septembre prochain. Dans certains cas, nous
                        pouvons constater que certains clients ne pourront pas être servis avant 2023 », a-t-il affirmé
                        à Bloomberg. Pour la PDG d’AMD Lisa Su, la situation pourrait s’améliorer un peu plus
                        rapidement, avec la création de nouvelles usines construites au début de la pandémie et qui vont
                        pouvoir commencer à produire pour permettre aux fournisseurs de rattraper la demande. Malgré
                        tout, la pénurie devrait s'étendre sur une bonne partie de l'année 2022…
                    </p>
                </ImageText>

                <ArticleLink
                    image={{src: social2Src, srcRet: social2SrcRet, webp: social2Webp, webpRet: social2WebpRet}}
                    url={'https://www.boursier.com/dossiers/les-jeux-video-avec-etoro/economie/sony-nintendo-microsoft-la-penurie-jusqu-a-quand-47344.html'} title={'Sony, Nintendo, Microsoft : la pénurie jusqu’à quand ?'}/>

                <ImageText rtl={true}
                           image={{src: social3Src, srcRet: social3SrcRet, webp: social3Webp, webpRet: social3WebpRet}}
                           classname={'sticky--image'}>
                    <p>
                        Outre la pénurie de composants électroniques, d’autres facteurs sont à surveiller comme le
                        durcissement des règles financières à l'encontre des géants technologiques qui se poursuit en
                        Chine. Afin de lutter contre la dépendance aux jeux vidéo, les autorités chinoises ont par
                        ailleurs décidé de limiter le temps que les mineurs peuvent consacrer aux jeux en ligne les
                        vendredis, week-ends et jours fériés. Selon cette nouvelle réglementation, les utilisateurs de
                        moins de 18 ans ne pourront jouer qu'entre 20 heures et 21 heures, heure locale, ces jours-là..
                    </p>

                    {
                        isMobile().phone ?
                            <div data-image-mobile/>
                            : null
                    }

                    <p>
                        Depuis août dernier, le géant Tencent, leader du marché chinois, a également imposé une nouvelle
                        restriction sur son titre phare, le très populaire « Honor of Kings ». Les moins de 18 ans ne
                        peuvent désormais y jouer que deux heures par jour au maximum pendant les vacances et une heure
                        en période scolaire. Au-delà, le jeu se verrouille ! Les spécialistes du secteur relativisent
                        toutefois l’impact de ces mesures qui devraient être ponctuelles et qui ne concernent qu’un
                        public très jeune, tandis que la moyenne d’âge des gamers tend globalement à s’élever...
                    </p>
                </ImageText>
            </div>
        </section>
    )
}
